import { Injectable, NgZone } from '@angular/core';
import { PHBHPFeaturePackageEvaluationService } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/ph-bhp-feature-package-evaluation.service';
import { forkJoin, Observable, of, Subject } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { ProfessionalSubCategoryDTO } from '../models/professional-sub-category-dto';
import { DepartmentType } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/Models/DepartmentType';
import { Department } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/Models/Department';
import { CatalogMasterService } from './catalog-master.service';
import { ProfessionalCategory } from '../models/professional-category';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/lib/ph-bhp-layout-package.service';
import { Ward } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/Models/Ward';
import { AppConfig } from '../app.config';

@Injectable({
  providedIn: 'root'
})
export class FiltersService {

  countryList: Array<any>;
  countryListSubject = new Subject<boolean>();
  institutionsList: Array<any> = [];
  institutionSubject = new Subject<boolean>();
  professionalCategoryList: ProfessionalCategory[];
  professionalCategorySubject = new Subject<boolean>();
  allSubCategoryList: ProfessionalSubCategoryDTO[];
  subCategoryList: ProfessionalSubCategoryDTO[];
  subCategoryListSubject = new Subject<boolean>();
  departmentList: Department[];
  departmentTypeList: DepartmentType[];
  departmentListSubject = new Subject<boolean>();
  departmentTypeListSubject = new Subject<boolean>();
  wardList: Ward[];
  wardListSubject = new Subject<boolean>();

  singleInstitution: boolean = false;
  showProfessionalSubcategory: boolean = false;

  roleId;
  country: any;
  institution: any;
  ward: any;
  department: any;
  departmentType: any;
  category: any;
  subCategory: any;
  userData: any;

  constructor(
    private service: PHBHPFeaturePackageEvaluationService,
    private catalogMasterService: CatalogMasterService,
    private layoutService: PHBHPLayoutPackageService,
    private config: AppConfig
  ) { }

  loadFilters(userData?) {
    if (!this.userData && userData) {
      this.userData = userData;
      this.userData.roleName = JSON.parse(this.userData.roleName);
    }
    if (this.config.userData) {
      this.userData = this.config.userData;
    }

    this.roleId = this.userData.roleName.roleId;

    if (this.roleId == 1) {
      this.loadFiltersDataForSA();
    } else {
      this.loadFiltersData();
    }
  }

  // TODO load info for SA
  loadFiltersDataForSA() {
    return forkJoin([
      this.getCountryList(),
      this.getDepartmentList(),
      this.getDepartmentTypesList(),
      this.getProfessionalCategoryDetails(),
      this.getSubCategoryDetails(),
    ]).subscribe(([countryList, departments, departmentTypes, professionalCategories, subCategories]) => {
      this.countryList = countryList;
      this.countryListSubject.next(true);
      this.professionalCategoryList = professionalCategories.sort((a, b) => this.layoutService.translateText(a.categoryName).localeCompare(this.layoutService.translateText(a.categoryName)));
      this.professionalCategorySubject.next(true);
      this.departmentList = departments.sort((a, b) => this.layoutService.translateText(a.departmentName).localeCompare(this.layoutService.translateText(a.departmentName)));
      this.departmentListSubject.next(true);
      this.departmentTypeList = departmentTypes.sort((a, b) => this.layoutService.translateText(a.departmentTypeName).localeCompare(this.layoutService.translateText(a.departmentTypeName)));
      this.departmentTypeListSubject.next(true);
      this.allSubCategoryList = subCategories.sort((a, b) => this.layoutService.translateText(a.subCategoryName).localeCompare(this.layoutService.translateText(a.subCategoryName)));
      this.subCategoryList = subCategories.sort((a, b) => this.layoutService.translateText(a.subCategoryName).localeCompare(this.layoutService.translateText(a.subCategoryName)));         
      this.subCategoryListSubject.next(true);
    });
  }

  loadFiltersData() {

    this.roleId = this.userData.roleName.roleId;
    this.country = this.userData.country;
    let institutionRequest: Observable<any>;
    if (this.roleId == 2 && this.userData && this.userData.country !== 0) {
      institutionRequest = this.getInstitutionByCountryId(this.userData.country)
    } else {
      institutionRequest = this.service.getUsersInstitutions(this.userData);

    }


    return forkJoin([
      institutionRequest,
      this.getDepartmentList(),
      this.getDepartmentTypesList(),
      this.getProfessionalCategoryDetails(),
      this.getSubCategoryDetails(),
    ]).subscribe(([institutions, departments, departmentTypes, professionalCategories, subCategories]) => {
      this.filterInstitutions(institutions);
      this.institutionSubject.next(true);
      this.professionalCategoryList = professionalCategories;
      this.professionalCategorySubject.next(true);
      this.departmentList = departments;
      this.departmentListSubject.next(true);
      this.departmentTypeList = departmentTypes;
      this.departmentTypeListSubject.next(true);
      this.allSubCategoryList = subCategories;
      this.subCategoryList = subCategories;
      this.subCategoryListSubject.next(true);
      this.getWardsByInstitutions();
    });
  }

  getInstitutionByCountryId(countryID): Observable<any> {
    return this.service.getInstitutionByCountryId(countryID)
  }

  getProfessionalCategoryDetails(): Observable<any> {
    return this.catalogMasterService.getProfessionalCategories()
  }

  getSubCategoryDetails(): Observable<any> {
    let countryId = this.userData.country;
    if (countryId && countryId != 0) {
      return this.catalogMasterService.getProfessionalSubCategoriesByCountry(countryId)
    } else {
      return of([]);
    }
  }

  getSubCategoryDetailsByCategoryId(id): Observable<any> {
    let countryId = this.userData.country;
    if (countryId && countryId != 0) {
      return this.catalogMasterService.getProfessionalSubCategoriesByCategoryId(id, countryId)
    } else {
      return of(null);
    }
  }

  getDepartmentList(): Observable<any> {
    return this.service.getDepartmentList()
  }

  getDepartmentTypesList(): Observable<any> {
    return this.service.getDepartmentTypeList()
  }

  getCountryList(): Observable<any> {
    return this.service.getCountry();
  }

  getAllWardsByInstitutionsIds(ids): Observable<any> {
    return this.service.getAllWardsByInstitutionsIds(ids)
  }


  getWardsByInstitutions() {

    if(this.institutionsList.length > 0) {
      let institutionsIds = this.institutionsList.map(inst => inst.institutionID).join(',');
      forkJoin([this.getAllWardsByInstitutionsIds(institutionsIds)]).subscribe((wardsLists) => {
        this.wardList = [];
        wardsLists.forEach((wards: Ward[]) => {
          if (!this.wardList) this.wardList = [];
          this.wardList = this.wardList.concat(wards);
        });
        this.wardListSubject.next(true);
      })
    }
  }


  onCountryChange(countryId: any) {
    return forkJoin([
      this.getInstitutionByCountryId(countryId),
    ])
  }


  filterInstitutions(res: any[]): void {
    this.institutionsList = res.filter((inst) => {
      return ((this.roleId > 2 ? inst.institution.institution.status : true)
        && (this.roleId <= 2 ? inst.institution.shareDataWithHartmann : true))
    }

    ).map((group) => group.institution);

    if (this.institutionsList.length > 0 && this.institutionsList[0].institution) {
      this.institutionsList = this.institutionsList.map(inst => inst.institution);
      this.institutionsList = this.institutionsList.sort((a, b) => a.institutionName.localeCompare(b.institutionName));
    }
  }

}
